(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  root.WinkyLashDirectory = api;
})(typeof window !== 'undefined' ? window : globalThis, function () {
  'use strict';
  var exclusions = /\b(diy|clusters?|bonders?|sealants?|glue|adhesives?|tweezers?|brush(?:es)?|tapes?|pads?|cleaners?|removers?|primers?|mirrors?|palettes?|pallets?|holders?|storage|training|mannequins?|rings?|shampoo|bottles?|nozzles?|dispensers?|accessor(?:y|ies)|tools?|cases?|scissors?)\b/i;
  var lashTerms = /\b(eyelash extensions?|eyelashes?|lash extensions?|lashes|lash|premade fans?)\b/i;
  var families = [/\b(premium silk|platinum|classic lash|volume eyelash|volume lash)\b/i, /\beasy fan\b/i, /\b(flat|ellipse)\b/i, /\bcamellia\b/i, /\b(yy|ww|y\/w|y shape|w shape|y-shape|w-shape)\b/i, /\bbottom lash/i, /\b(foxy|fox eye)\b/i, /\bspike/i, /\b5d flower/i, /\bwet\b/i, /\bnarrow w/i, /\bu[- ]?shape/i, /\bbrown/i, /\b(colou?red|color|ombre)\b/i, /\bpremade fan/i, /\b(lc|ld|lu|l\+?|m) curl\b/i];
  function isProfessionalLash(title) { return lashTerms.test(title || '') && !exclusions.test(title || ''); }
  function thicknessRank(title) {
    var value = String(title || '').match(/\b0[.-](03|05|07|10|15|20)\s*mm\b/i);
    if (value) return ['03', '05', '07', '10', '15', '20'].indexOf(value[1]);
    return /\b2[.-]0\s*mm\b/i.test(title || '') ? 5 : 99;
  }
  function familyRank(title) {
    for (var i = 1; i < families.length; i += 1) if (families[i].test(title || '')) return i;
    return families[0].test(title || '') ? 0 : 98;
  }
  function matchesGroup(title, group) {
    if (!isProfessionalLash(title)) return false;
    var rules = {
      'volume-classic': /\b(premium silk|platinum|classic lash|volume eyelash|volume lash)\b/i, 'easy-fan': /\beasy fan\b/i,
      'flat-ellipse': /\b(flat|ellipse)\b/i, camellia: /\bcamellia\b/i, 'y-w-shape': /\b(yy|ww|y\/w|y shape|w shape|y-shape|w-shape)\b/i,
      bottom: /\bbottom lash/i, foxy: /\b(foxy|fox eye)\b/i, spike: /\bspike/i, '5d-flower': /\b5d flower/i,
      wet: /\bwet\b/i, 'narrow-w': /\bnarrow w/i, 'u-shape': /\bu[- ]?shape/i, brown: /\bbrown/i,
      color: /\b(colou?red|color|ombre)\b/i, premade: /\bpremade fan/i, 'special-curl': /\b(lc|ld|lu|l\+?|m) curl\b/i,
      classic: /\b(classic lash|0[.-](10|15|20)\s*mm|2[.-]0\s*mm)\b/i, volume: /\b(volume|0[.-](03|05|07)\s*mm)\b/i,
      wispy: /\bwispy\b/i, anime: /\b(anime|manga)\b/i
    };
    if (/^thickness-(003|005|007|010|015|020)$/.test(group || '')) {
      return thicknessRank(title) === ['003', '005', '007', '010', '015', '020'].indexOf(group.slice(-3));
    }
    return group === 'curl' || !group || !rules[group] || rules[group].test(title || '');
  }
  function compareTitles(a, b) { return familyRank(a) - familyRank(b) || thicknessRank(a) - thicknessRank(b) || String(a).localeCompare(String(b), 'en', { sensitivity: 'base' }); }
  function applyDirectoryRules() {
    if (typeof document === 'undefined') return;
    var group = new URLSearchParams(root.location.search).get('wbl_group');
    if (!group) return;
    var grid = document.querySelector('[data-contentlm-replace].t4s-products');
    if (!grid) return;
    var cards = Array.prototype.slice.call(grid.querySelectorAll(':scope > .t4s-product'));
    function titleOf(card) {
      var source = card.querySelector('[data-wbl-title]');
      return source ? source.getAttribute('data-wbl-title') || '' : '';
    }
    cards.forEach(function (card) { card.hidden = !matchesGroup(titleOf(card), group); });
    cards.filter(function (card) { return !card.hidden; }).sort(function (a, b) {
      return compareTitles(titleOf(a), titleOf(b));
    }).forEach(function (card) { grid.appendChild(card); });
  }
  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', applyDirectoryRules); else applyDirectoryRules();
    document.addEventListener('shopify:section:load', applyDirectoryRules);
  }
  return { isProfessionalLash: isProfessionalLash, thicknessRank: thicknessRank, familyRank: familyRank, matchesGroup: matchesGroup, compareTitles: compareTitles, applyDirectoryRules: applyDirectoryRules };
});
